export default __webpack_public_path__ + "static/media/240.f5e0d770.jpg";